/**
 * TODO: Update this component to use your client-side framework's link
 * component. We've provided examples of how to do this for Next.js, Remix, and
 * Inertia.js in the Catalyst documentation:
 *
 * https://catalyst.tailwindui.com/docs#client-side-router-integration
 */

import * as Headless from "@headlessui/react";
import React, { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";

export const Link = forwardRef(function Link(
  props: { href: string } & Omit<React.ComponentPropsWithoutRef<"a">, "to">,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  const { href, ...rest } = props;

  // Check if the link is external (starts with http:// or https://), special (like mailto:), or an anchor link
  const isExternal =
    href &&
    (href.startsWith("http://") ||
      href.startsWith("https://") ||
      href.startsWith("mailto:") ||
      href.startsWith("tel:") ||
      href.startsWith("#"));

  return (
    <Headless.DataInteractive>
      {isExternal ? (
        <a href={href} {...rest} ref={ref} />
      ) : (
        <RouterLink to={href} {...rest} ref={ref} />
      )}
    </Headless.DataInteractive>
  );
});
